/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef } from 'react'
import CustomModal from '../../../../../components/CroreUIModal'
import { ArrowLeftSVG, ArrowRight, PrinterSVG } from '../../../../../components/IconSvg'
import { CFormSelect, CSpinner } from '@coreui/react'
import { enToPersianChar, iframeToPrint, setInvoiceContent } from '../../../../../components/helper'
import {
    generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestAction, getApplicationContractTypeRequestAction,
    getPrepareForGatewayRequestAction, postTryReserveRequestedLinesRequestAction, resetPurchasePropsAction
} from '../../../../../service/actions/purchaseActions'
import { AppLicationContractType } from '../../../../../service/interfaces/purchase'
import { useSelector } from 'react-redux'
import { IRootState } from '../../../../../service/store'
import { useLocation, useNavigate, useParams } from 'react-router-dom'
import CustomValuesHook from '../../../../../Hooks/customValuesHook'
import { useDispatch } from 'react-redux'
import { toast } from 'react-toastify'
import { generateHtmlPreInvoiceToNewlyCustomerRegistered } from '../../../../../service/types/Purchase/apiRequestTypes'
import InvoiceType from '../../../../../components/InvoiceType'
import { AsanPardakht, Pasargod, Mellat } from '../../../../../components/gatewaysImages'
import { Types } from '../../../../../service/types'


const Invoice = () => {
    const getAppContractTypePending: boolean = useSelector((state: IRootState) => state.purchaseReducer.getApplicationContractTypePending)
    const applicationContractType: AppLicationContractType[] | null = useSelector((state: IRootState) => state.purchaseReducer.applicationContractType)
    const htmlPreInvoice: any | null = useSelector((state: IRootState) => state.purchaseReducer.genHtmlPINRCResult)
    const getHtmlPreInvoiceToCustomerPending: boolean = useSelector((state: IRootState) => state.purchaseReducer.genHtmlPINRCPending)
    const gatewayPrepareResult: any | undefined = useSelector((state: IRootState) => state.purchaseReducer.gatewayPrepareResult)
    const postTryReserveRequestedLinesResult: any | undefined = useSelector((state: IRootState) => state.purchaseReducer.postTryReserveRequestedLinesResult)
    const postTryReserveRequestedLinesPending: boolean | undefined = useSelector((state: IRootState) => state.purchaseReducer.postTryReserveRequestedLinesPending)
    const getHtmlPreInvoiceToCustomerError: any | undefined = useSelector((state: IRootState) => state.purchaseReducer.genHtmlPINRCError)
    const getHtmlPreInvoiceToCustomerSuccess: any | undefined = useSelector((state: any) => state.purchaseReducer.getHtmlPreInvoiceToCustomerSuccess)
    const getPrepareForGatewayPending: any | undefined = useSelector((state: any) => state.purchaseReducer.getPrepareForGatewayPending)

    const params = useParams()
    let formRef = useRef<HTMLFormElement>(null)



    const [states, setStates] = CustomValuesHook({
        isUseDiscount: false,
        isUsedDiscount: false,
        discountQuery: ""
    })
    const navigate = useNavigate()
    const location = useLocation()
    const dispatch = useDispatch()


    useEffect(() => {
        dispatch({ type: Types.RESET_PURCHASE_CREATE_INVOICE_PROPS })
        if (location.state?.productId) {
            dispatch(getApplicationContractTypeRequestAction({ productId: location.state?.productId }))
        }
        return () => {
            setStates({
                discountQuery: "",
                isUsedDiscount: false
            })
            dispatch(resetPurchasePropsAction())
        }
    }, [])



    useEffect(() => {
        if (gatewayPrepareResult) {
            let hiddenInputFields: any[] = [];

            gatewayPrepareResult?.hiddenInputFields.forEach((item: any) => {
                hiddenInputFields.push({
                    name: item.name,
                    value: item.value
                });
            })
            setStates({
                method: gatewayPrepareResult.method,
                action: gatewayPrepareResult.action,
                hiddenInputFields: hiddenInputFields
            })
            dispatch(resetPurchasePropsAction())
            setTimeout(() => {
                formRef?.current?.submit()
                // setStates({ displayGateway: false })

            }, 1000)
        }

    }, [gatewayPrepareResult])

    useEffect(() => {

        if (postTryReserveRequestedLinesResult) {

            let callBackUrl = "";

            callBackUrl = `/landingPurchase/step-5/${location.state?.packageType}/${htmlPreInvoice?.invoiceId}`;

            navigate(callBackUrl)



        }
    }, [postTryReserveRequestedLinesResult])


    useEffect(() => {

        if (getHtmlPreInvoiceToCustomerError) {
            if (getHtmlPreInvoiceToCustomerError?.error) {
                toast.error(getHtmlPreInvoiceToCustomerError?.error)
                setStates({ isUsedDiscount: false })
            }
        }


    }, [getHtmlPreInvoiceToCustomerError])

    useEffect(() => {
        if (htmlPreInvoice) {
            setStates({
                invoiceId: htmlPreInvoice.invoiceId,
                lastInvoice: htmlPreInvoice,
                gateways: htmlPreInvoice.paymentGatewayList,
                defaultGateway: htmlPreInvoice.defaultGateway,
                selectedGateway: htmlPreInvoice.defaultGateway.gatewayId
            })
            if (states.discountQuery != null && states.discountQuery !== "") {
                toast.success('کد تخفیف با موفقیت اعمال شد.')
                setStates({ isUsedDiscount: true })
            } else {
                setStates({ isUsedDiscount: false, discountQuery: "" })
            }
            setInvoiceContent('iframeInvoice', htmlPreInvoice.htmlContent)
            // ref.current?.innerHTML=htmlPreInvoice.HTMLContent
            // document.getElementById('iframeInvoice').contentWindow.document.body.innerHTML = htmlPreInvoice.HTMLContent;
        }
        else {
            // setInvoiceContent('iframeInvoice', '<div></div>')
        }
    }, [htmlPreInvoice])




    useEffect(() => {
        if (applicationContractType && applicationContractType.length > 0) {
            const sortedList = applicationContractType?.sort((a: AppLicationContractType, b: AppLicationContractType) => {
                return a.DiscountPercent - b.DiscountPercent;
            })
            setStates({
                contractTypes: sortedList,
                contractTypeId: sortedList[0].Id
            })

            getInvoice(sortedList[0].Id)
        }
    }, [applicationContractType])

    useEffect(() => {
        if (states.discountQuery === null && !states?.isUsedDiscount && applicationContractType && applicationContractType.length > 0) {
            getInvoice(null)
        }
    }, [states.discountQuery, states.isUsedDiscount])

    const getInvoice = (contractId: string | null) => {

        let payload: generateHtmlPreInvoiceToNewlyCustomerRegistered = {
            CustomerId: location?.state?.CustomerId,
            ProductType: location?.state?.productType,
            ProductId: location?.state?.productId,
            ContractTypeId: contractId ? contractId : states?.contractTypeId,
            LineIds: location?.state?.selectedLine ? [location?.state?.selectedLine.Id] : [],
            Referrer: location?.state?.referrer,
            UtmInfo: {
                Term: location?.state?.utm_term,
                Medium: location?.state?.utm_medium,
                Campaign: location?.state?.utm_campaign,
                Source: location?.state?.utm_source
            },
            DiscountCode: undefined
        }
        if (states.discountQuery !== '') {
            payload.DiscountCode = states.discountQuery
        }
        dispatch(generateHtmlPreInvoiceToNewlyCustomerRegisteredRequestAction({ ...payload }))
    }

    const handleDone = () => {
        console.log("htmlPreInvoice", htmlPreInvoice)
        dispatch(postTryReserveRequestedLinesRequestAction(htmlPreInvoice?.invoiceId))
    }

    const handleSelectBankGateway = () => {

        let callBackUrl = "";
        if (params['*']?.indexOf('purchaseLine') !== -1) {
            callBackUrl = `#/landingPurchase/step-5/${location.state.productType}`;//${location.state.urlSearch}`;
        } else {
            callBackUrl = `#/landingPurchase/step-5/${location.state.productType}`;//${location.state.urlSearch}`;

        }
        dispatch(getPrepareForGatewayRequestAction({
            invoiceId: htmlPreInvoice?.invoiceId,
            gatewayId: states.selectedGateway,
            invoiceType: states.invoiceType,
            callbackUrl: encodeURIComponent(callBackUrl)
        }))
        // setStates({ displayGateway: false })
    }


    const bankGatewayModalBody = () => {
        return (<div className='gateways-container'>
            {states?.gateways?.map((item: any, idx: number) => {
                if (item?.name !== 'ZarinPal') {
                    return (<div key={idx}
                        onClick={() => setStates({ selectedGateway: item.gatewayId })}
                        className={`gateway-box ${states.selectedGateway === item.gatewayId ? 'selected' : ''}`}>
                        <figure>
                            {/* <img src={require(`./images/${item.name}.png`)} alt={item.Name} /> */}
                            <img src={item.name === "Pasargod" ? Pasargod : item.name === "Asanpardakht" ? AsanPardakht : item.name === "Mellat" ? Mellat : null} />

                            <figcaption > {item.caption}</figcaption>
                        </figure>
                    </div>)
                }
            }


            )}
        </div>)
    }
    const modalBankGatewayFooterComponent = () => {
        return (<div className='d-flex justify-content-center w-100'>
            <button type='button' className='btn btn-success' disabled={getPrepareForGatewayPending}
                onClick={handleSelectBankGateway} > پرداخت صورت حساب
                {getPrepareForGatewayPending && <CSpinner size="sm" />}
            </button>
        </div>)

    }
    console.log("invoiceType", states.invoiceType)

    return (
        <div className='content-container invoice-context'>
            <div className='factor-step-header' >

                <div className='form-inline'>
                    <label className='label-control' >مدت قرارداد</label>
                    <CFormSelect className='form-control' disabled={
                        applicationContractType !== undefined &&
                        applicationContractType !== null &&
                        applicationContractType.length === 1} onChange={(e) => {
                            setStates({
                                contractTypeId: e.target.value
                            });
                            getInvoice(e.target.value)
                        }}>
                        {applicationContractType && applicationContractType.map((ct: any, idx: number) => {
                            let discount = ``
                            if (ct.DiscountPercent > 0) {
                                discount = `(${enToPersianChar(ct.DiscountPercent)}% تخفیف)`
                            }
                            return (<option value={ct.Id} key={idx} >{ct.Title}  {discount}</option>)
                        }
                        )}
                    </CFormSelect>
                    {(htmlPreInvoice?.amount > 0 || states?.discountQuery !== "") ? <div className='discount-container'>
                        {!states.isUseDiscount ? <span onClick={() => setStates({ isUseDiscount: true })}>کد تخفیف؟</span> :
                            <><input type='text'
                                disabled={states.isUsedDiscount}
                                placeholder='کد تخفیف'
                                value={states.discountQuery ? states.discountQuery : ''}
                                onChange={(e) => setStates({ discountQuery: e.target.value })} />
                                {!states.isUsedDiscount && <button className='send-discount-btn' onClick={() => {
                                    if (states.discountQuery !== "") {
                                        getInvoice(null)
                                    }
                                }} >بررسی</button>}
                                {states.isUsedDiscount && <button className='send-discount-btn' onClick={() => {
                                    setStates({ discountQuery: null, isUsedDiscount: false });
                                }} >حذف</button>}</>

                        }
                    </div> : <div>
                    </div>}

                </div>
                <div className='desktop-context'>
                    <button className='pre-invoice-print-btn btn' onClick={() => iframeToPrint("iframeInvoice")}>
                        <PrinterSVG />
                        چاپ پیش‌فاکتور
                    </button>
                </div>
                <div className='mobile-context'>
                    <span onClick={() => iframeToPrint("iframeInvoice")}>
                        <PrinterSVG />
                    </span>
                </div>
            </div>

            <div className='invoice-context'>
                {(getHtmlPreInvoiceToCustomerPending || getAppContractTypePending) && <div className='invoice-loading' ></div>}
                <iframe id="iframeInvoice"
                    // dangerouslySetInnerHTML={{ __html: htmlPreInvoice?.HTMLContent }}

                    title='invoice' className={!(getHtmlPreInvoiceToCustomerPending || getAppContractTypePending) ? "iframeInvoiceStyle" : ""}>

                </iframe>

            </div>


            {(htmlPreInvoice?.amount > 0 || states.discountQuery !== "" || states.isUsedDiscount) &&
                <InvoiceType setInvoiceType={(type: number) => setStates({ invoiceType: type })} />}
            <div className='d-flex justify-content-between mt-2 btn-container'>
                <button className='btn btn-success'
                    onClick={() => {
                        dispatch({ type: Types.RESET_PURCHASE_CREATE_INVOICE_PROPS })
                        navigate(`/landingPurchase/step-3/${location?.state?.productType}/${location?.state?.productId}/${location?.state?.contractTypeId}${location.state.urlSearch}`
                            , { state: { ...location?.state } })



                    }}
                >
                    <ArrowRight fill='#fff' />
                    مرحله قبل</button>

                <form name='invoiceForm' ref={formRef} method={states.method} action={states.action}>
                    {states.hiddenInputFields?.map((item: any, idx: number) => <input type='hidden' key={idx} name={item.name} value={item.value} />)}
                    {htmlPreInvoice?.amount > 0 ? <button type='button'
                        onClick={() => setStates({ displayGateway: true, selectedGateway: states.defaultGateway.gatewayId })}

                        className='btn btn-success'>درگاه پرداخت
                        <ArrowLeftSVG fill='#fff' />
                    </button> : <button type='button'
                        onClick={handleDone}
                        disabled={postTryReserveRequestedLinesPending}
                        className='btn btn-success'>تایید
                        <ArrowLeftSVG fill='#fff' />
                    </button>}
                </form>

            </div>
            <CustomModal
                confirmAction={handleSelectBankGateway}
                setShow={() => setStates({ displayGateway: false })}
                title={"درگاه مورد نظر خود را انتخاب کنید"}
                component={bankGatewayModalBody}
                show={states.displayGateway}
                confirmButtonText="تایید"
                cancelButtonText="انصراف"
                footerComponent={modalBankGatewayFooterComponent}
            />
        </div>
    )
}

export default Invoice